(() => {
  const WRAP = ".product__media-list .product__media-image-wrapper";
  const ACTIVE = "is-zooming";

  const finePointer = () => window.matchMedia("(hover: hover) and (pointer: fine)").matches;

  function setOrigin(wrapper, e) {
    const img = wrapper.querySelector("img");
    if (!img) return;

    const r = wrapper.getBoundingClientRect();
    const x = ((e.clientX - r.left) / r.width) * 100;
    const y = ((e.clientY - r.top) / r.height) * 100;

    img.style.setProperty("--fz-x", `${x}%`);
    img.style.setProperty("--fz-y", `${y}%`);
  }

  function onEnter(e) {
    if (!finePointer()) return;
    const wrapper = e.target.closest(WRAP);
    if (!wrapper) return;

    wrapper.classList.add(ACTIVE);
  }

  function onMove(e) {
    if (!finePointer()) return;
    const wrapper = e.target.closest(WRAP);
    if (!wrapper || !wrapper.classList.contains(ACTIVE)) return;

    setOrigin(wrapper, e);
  }

  function onLeave(e) {
    const wrapper = e.target.closest(WRAP);
    if (!wrapper) return;

    wrapper.classList.remove(ACTIVE);
    const img = wrapper.querySelector("img");
    if (img) {
      img.style.removeProperty("--fz-x");
      img.style.removeProperty("--fz-y");
    }
  }

  function bind(root = document) {
    // capture=true ensures it still works inside flickity + shadowy custom elements
    root.addEventListener("pointerenter", onEnter, true);
    root.addEventListener("pointermove", onMove, true);
    root.addEventListener("pointerleave", onLeave, true);
  }

  bind();

  // Safety for theme editor / section reloads
  document.addEventListener("shopify:section:load", () => bind());
})();